// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__RhGWV","info":"UpdateTermsInfo_info__2PSLC"};